import { ArtAssetCardApi } from '@entities/art-asset';

import { ARTWORKS_PER_PAGE } from '../configs/constants';
import type { ArtAssetReadManyResponse, ReadArtAssetPageDataArguments } from '../types';

export async function readArtAssetPageData({
  fetch,
  page,
  offset,
  loadMore,
  institutionId,
  order,
  sort,
  search,
  medium,
  styles,
  artists,
  countries,
  token_status,
  price,
  artists_slugs,
  styles_slugs,
  medium_slugs,
  countries_slugs,
  curator_review,
  creation_year,
  original_size_x,
  original_size_y,
  art_asset_type,
}: ReadArtAssetPageDataArguments): Promise<ArtAssetReadManyResponse> {
  const artAssetCardApi = new ArtAssetCardApi(fetch);

  const { artworks, totalCount } = await artAssetCardApi.readMany({
    page,
    loadMore,
    institutionId,
    offset: offset || (page - 1) * ARTWORKS_PER_PAGE,
    order,
    sort,
    search,
    perPage: ARTWORKS_PER_PAGE,
    medium,
    styles,
    artists,
    countries,
    token_status,
    price,
    artists_slugs,
    styles_slugs,
    medium_slugs,
    countries_slugs,
    curator_review,
    creation_year,
    original_size_x,
    original_size_y,
    art_asset_type,
  });

  return {
    artworks,
    totalCount,
    maxPage: Math.ceil(totalCount / ARTWORKS_PER_PAGE),
  };
}
